import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button/Button';
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/Dialog/Dialog';
import { DID_GRANT_PERMISSION_STORAGE_KEY, usePushNotifications } from '@/features/notifications/hooks/usePushNotifications';
import { useIsInstalled } from '@/hooks/pwa/useIsInstalled';

import pushIllustrationS from '@/features/management/assets/push_illustration-s.png';

export const EnableNotificationsBoundary = () => {
  const { t } = useTranslation('components', { keyPrefix: 'notificationsModal' });
  const { permission, isLoading, enable } = usePushNotifications();

  const isInstalled = useIsInstalled();

  const [isOpened, setIsOpened] = useState(false);

  const handleSkip = () => {
    localStorage.setItem(DID_GRANT_PERMISSION_STORAGE_KEY, 'skipped');
    setIsOpened(false);
  };

  useEffect(() => {
    const didInteract =
      localStorage.getItem(DID_GRANT_PERMISSION_STORAGE_KEY) === 'true' || localStorage.getItem(DID_GRANT_PERMISSION_STORAGE_KEY) === 'skipped';

    if (isInstalled && permission === 'default' && !didInteract) {
      setIsOpened(true);
    } else if (permission !== 'default') {
      setIsOpened(false);
    }
  }, [permission, isInstalled]);

  return (
    <Dialog open={isOpened} onOpenChange={() => setIsOpened(false)}>
      <DialogContent className='tablet:max-h-[744px] tablet:max-w-[460px] max-tablet:min-w-screen flex h-full flex-col gap-0'>
        <DialogHeader className='tablet:mb-6 mb-5'>
          <DialogTitle className='text-heading-s-medium'>{t('title')}</DialogTitle>
        </DialogHeader>
        <DialogBody className='mb-8 flex flex-1 flex-col items-center justify-center gap-8 text-center'>
          <div className='bg-fill-background-light flex w-full items-end justify-center rounded-xl pt-6'>
            <img alt={t('imgAlt')} src={pushIllustrationS} className='max-w-[300px] translate-x-5' />
          </div>
          <div className='flex flex-col gap-4'>
            <p className='text-heading-m-semibold w-[320px] max-w-full'>{t('heading')}</p>
            <p className='text-body-m-regular text-text-default-secondary w-[320px] max-w-full'>{t('description')}</p>
          </div>
        </DialogBody>
        <DialogFooter className='tablet:flex-col flex-col gap-3'>
          <Button onClick={() => void enable()} disabled={isLoading} isLoading={isLoading} className='w-full'>
            {t('enableButton.label')}
          </Button>
          <Button onClick={handleSkip} variant='text-secondary' className='w-full'>
            {t('skip.label')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
